import { render, staticRenderFns } from "./_pageLayout.vue?vue&type=template&id=6267f8ce"
import script from "./_pageLayout.vue?vue&type=script&lang=js"
export * from "./_pageLayout.vue?vue&type=script&lang=js"
import style0 from "./_pageLayout.vue?vue&type=style&index=0&id=6267f8ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports